import { useCallback } from 'react';

import { isBlogWizardTemplateTool, isCustomMultiPromptTool } from 'src/data/generationTool';
import { PROJECT_PANEL, PROJECT_TYPE } from 'src/data/project';
import { useHistory } from 'src/lib/hooks';
import { formatRoute } from 'src/lib/routing';
import { ROUTES } from 'src/routes';

import { useCreateProject } from './useCreateProject';

export const useProjectTemplatePopupSubmitHandler = () => {
  const history = useHistory();
  const createProject = useCreateProject();

  return useCallback(
    ({ generationTool, customToolData, subTemplateId }) => {
      // TODO: check if we need this condition to pass customMultiPromptGroup
      // customMultiPromptGroup: customToolData?.status === TEMPLATE_STATUS.released ? customToolData?.templateGroup : undefined,

      // A custom-template card with no template behind it can only mean "build one". It used to be
      // recognised by a missing projectType, which a saved template no longer carries either.
      if (!customToolData && isCustomMultiPromptTool(generationTool)) {
        history.push(formatRoute(ROUTES.MULTI_PROMPT_BUILDER));
        return;
      }

      if (isBlogWizardTemplateTool(generationTool)) {
        createProject(PROJECT_TYPE.document, { sidebarItem: PROJECT_PANEL.blogWizard });
        return;
      }

      if (subTemplateId) {
        createProject(PROJECT_TYPE.document, { generationTool, subTemplateId });
        return;
      }

      createProject(PROJECT_TYPE.document, {
        generationTool,
        customMultiPromptId: customToolData?.id,
        customMultiPromptGroup: customToolData?.templateGroup,
      });
    },
    [createProject, history]
  );
};
